import { useDispatch } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { reloadThreadsData } from '../actions/reloadThreadsData';
import { jsx as _jsx } from "react/jsx-runtime";
const ConnectedRefreshLink = () => {
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsx(Link, {
    onClick: () => {
      dispatch(reloadThreadsData());
    },
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "ConversationsInboxUI.threadBatchOperations.alert.refreshLink"
    })
  });
};
ConnectedRefreshLink.displayName = 'RefreshLink';
export default ConnectedRefreshLink;